interface InfraPageData {
  orgId: string | number;
}

interface InfraUpdateData {
  id?: string | number;
  org?: string | number;
  orgId?: string | number;
  type?: string;
  [key: string]: string | number | undefined;
}

interface InfraCreateData {
  orgId?: string | number;
}

interface InfraRoute {
  page: string;
  updatePage: string;
  createPage: string;
  getPage: (data: InfraPageData) => string;
  getUpdatePage: (data: InfraUpdateData) => string;
  getCreatePage: (data?: InfraCreateData) => string;
}

const _infraRoute: InfraRoute = {
  page: "/infrastructures_admin",
  updatePage: "/infrastructures_update",
  createPage: "",
  getPage: (data) => {
    return `/infrastructures_admin?org=${data.orgId}`;
  },
  getUpdatePage: (data) => {
    data.org = data.org || data.orgId;
    data.type = data.type || "view";

    const queryString = new URLSearchParams(
      data as Record<string, string>
    ).toString();
    return `/infrastructures_update?${queryString}`;
  },
  getCreatePage: (data) => {
    if (data?.orgId) return `/infrastructures_update?org=${data.orgId}`;
    return `/infrastructures_update?`;
  },
};

export default _infraRoute;
